import morphdom from 'morphdom';
import jQuery from 'jquery';

let _vhtml = function(element, html) {
  // Клонируем элемент без детей, вставляем новый контент
  const target = element.cloneNode(false);
  target.innerHTML = html;

  // morphdom сравнит реальный DOM с целевым и пропатчит только различия
  return morphdom(element, target);
};

let vhtml = function(html) {
  return this.map(function() {
    return _vhtml(this, html);
  });
};

jQuery.fn.vhtml = vhtml;
